import { UserLeadSettings } from '@cutr/constants/cutlist';
import { WindowOrder } from '@cutr/constants/windows/windows';
import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs } from 'react-router-dom';

import { windowApi } from '../windowApi';
import { getOrderQuery } from './crud';
import { useHydrateWindowStore } from './mappers';

export const orderLoader =
  (queryClient: QueryClient) =>
  async ({ params }: LoaderFunctionArgs): Promise<WindowOrder> => {
    const { orderId } = params;

    if (!orderId) {
      throw new Error('Order ID is required');
    }

    const query = getOrderQuery(orderId);
    const hydrateStore = useHydrateWindowStore();

    // cache hit
    const orderCache = queryClient.getQueryData<WindowOrder>(query.queryKey);
    if (orderCache) {
      hydrateStore(orderCache);
      return orderCache;
    }

    const freshOrder = await queryClient.fetchQuery(query);
    hydrateStore(freshOrder);

    return freshOrder;
  };

export type OrderLoaderType = Awaited<
  ReturnType<ReturnType<typeof orderLoader>>
>;

export const windowSettingsLoader = async (): Promise<UserLeadSettings> => {
  return windowApi.getOrderSettings();
};

export type WindowSettingsLoaderType = Awaited<
  ReturnType<typeof windowSettingsLoader>
>;
